import {useEffect, useMemo, useState} from "react";
import Icon, {plusIcon, companyIcon} from "../../components/Icon/Icon";
import Table from "../../components/Table/Table";
import Avatar from "../../components/Avatar/Avatar";
import {useNavigate} from "react-router-dom";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import Button from "../../components/Button/Button";
import Actions from "../../components/Actions/Actions";
import PageLayout from "../../components/PageLayout/PageLayout";
import ClientActions from "../../api/ClientsActions";

const Clients = () => {
    const navigate = useNavigate();

    const [clients, setClients] = useState([]);
    const [deleteModal, setDeleteModal] = useState(null);

    useEffect(() => {
        ClientActions.loadClients(setClients);
    }, []);

    const handleDeleteClient = () => {
        if (deleteModal !== null) {
            ClientActions.deleteClient(deleteModal.id, _ => {
                setClients(prevClients => prevClients.filter(client => client.id !== deleteModal.id));
                setDeleteModal(null);
            });
        }
    };

    const columns = useMemo(() => [
        {
            accessorKey: "name",
            header: "Company name",
            cell: ({row}) => {
                const name = row.original.name;
                const color = row.original.color;
                const logo = row.original.logo;


                return (
                    <div>
                        <Avatar
                            name={name}
                            url={logo?.url}
                            color={color}
                        />
                        {name}
                    </div>
                );
            }
        },
        {
            accessorKey: "actions",
            header: "Actions",
            cell: ({row}) => {
                const id = row.original.id;

                return (
                    <Actions
                        onEdit={() => navigate(`/clients/client/${id}`)}
                        onDelete={() => setDeleteModal(row.original)}
                    />
                );
            }
        }
    ], [navigate]);

    return (
        <PageLayout
            titlePage="Clients"
            icon={companyIcon}
            actions={
                <Button
                    className="add"
                    onClick={() => navigate("/clients/client")}
                >
                    <Icon svg={plusIcon} />
                    Add New
                </Button>
            }
        >
            <Table
                data={clients}
                columns={columns}
            />

            {
                deleteModal &&
                <DeleteModal
                    onClose={() => setDeleteModal(null)}
                    onConfirm={handleDeleteClient}
                    title="Deleting client"
                    message={`Are you sure you want to delete client "${deleteModal?.name}"?`}
                />
            }
        </PageLayout>
    );
};

export default Clients;